import {apiFetch} from '../../../hooks/useFetchApi';

export async function addNotification(data) {
  try {
    const resp = await apiFetch(`${process.env.REACT_APP_API_URL}/proxy/notification`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    return resp;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export async function updateNotification(id, data) {
  try {
    const resp = await apiFetch(`${process.env.REACT_APP_API_URL}/proxy/notification/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    return resp;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export async function getNotificationById(id) {
  try {
    const resp = await apiFetch(`${process.env.REACT_APP_API_URL}/proxy/notification/${id}`);
    return resp;
  } catch (error) {
    console.error(error);
    return null;
  }
}
